import {
  type AllConciseBranches,
  useFetchAllConciseBranches,
} from '@festina-life/api'
import { useMemo } from 'react'

import { useConfigurationComponentAvailability } from '../../hooks/useConfigurationComponentAvailability'
import { useAvailableServersForConfiguration } from '../../system/useAvailableServersForConfiguration'

export const useAllConciseBranches = () => {
  const isConfigurationComponentAvailable =
    useConfigurationComponentAvailability()
  const allServers = useAvailableServersForConfiguration()

  const { data: conciseBranches } = useFetchAllConciseBranches({
    servers: allServers,
    enabled: isConfigurationComponentAvailable,
  })

  const emptyConciseBranches: AllConciseBranches = useMemo(
    () => Object.fromEntries(allServers.map((server) => [server, []])),
    [allServers],
  )

  return conciseBranches ?? emptyConciseBranches
}
